import * as __req_0 from "@assets/images/ReplayButton.svg";
import React, { useRef, useEffect, useState } from "react";

// UserActionVideo
const UserActionVideo = ({ index, action, actionIndex }) => {
  const videoRef = useRef(null);
  const [ended, setEnded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setEnded(false);
    setLoading(true);
    setError(false);
    if (videoRef.current) {
      videoRef.current.muted = true;
    }

    if (index === actionIndex) {
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          const playPromise = videoRef.current.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {});
          }
        }
      }, 300);
    }
  }, [index, action]);

  const handleReplay = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      setEnded(false);
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    }
  };

  if (error) {
    return (
      <div className="useraction-video-container useraction-video-error">
        <span
          className="ion-videocamera"
          style={{ fontSize: 32, marginBottom: 8 }}
        />
        <span>Video unavailable</span>
      </div>
    );
  }

  return (
    <div className="useraction-video-container">
      {loading && (
        <div className="useraction-video-spinner">
          <span className="ion-load-c spin" />
        </div>
      )}
      {ended && !loading && (
        <img
          className="replay-button"
          onClick={handleReplay}
          src={(__req_0.default !== undefined ? __req_0.default : __req_0)}
        />
      )}
      <video
        ref={videoRef}
        src={action.video}
        poster={action.image}
        playsInline
        controls
        muted
        className="useraction-video-player"
        onCanPlay={() => setLoading(false)}
        onEnded={() => setEnded(true)}
        onPlay={() => setEnded(false)}
        onError={() => {
          setLoading(false);
          setError(true);
        }}
      />
    </div>
  );
};

export default UserActionVideo;
